<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>

    <div class="sessions" v-else>
      <!-- ------------------------------------- -->
      <!-- DELIVERY TYPES -->
      <!-- ------------------------------------- -->

      <h5 class="font-weight-bolder">Delivery Types</h5>

      <b-button variant="primary" size="md" class="ml-4 mt-2"
        v-if="!addDelivery"
        @click="addDelivery = true">
        Add Delivery Type
      </b-button>

      <div class="mt-2" ref="sessionForm"></div>

      <!-- ADD / EDIT DELIVERY -->
      <b-form class="mt-4" v-if="addDelivery" @submit.prevent="createDelivery">
        <b-form-group>
          <span class="alert alert-success text-center" v-if="successResponse">
            {{ successResponse }}
          </span>
          <h6 v-if="responseErrors.deliveryCreated" class="text-success">
            {{ responseErrors.deliveryCreated[0] }}
          </h6>
        </b-form-group>

        <b-form-group>
          <b-input
            placeholder="Delivery Name"
            v-model="delivery.name"
            :class="{ 'is-invalid': responseErrors.name }"
            class="text-center"
          ></b-input>

          <span class="text-danger" v-if="responseErrors.name">
            {{ responseErrors.name[0] }}
          </span>
        </b-form-group>

        <b-form-group>
          <b-form-select
            v-model="delivery.view_order"
            :options="viewOrderList"
            class="text-center"
            :class="{ 'is-invalid': responseErrors.view_order }"
          />

          <span class="text-danger ml-4" v-if="responseErrors.view_order">
            {{ responseErrors.view_order[0] }}
          </span>
        </b-form-group>

        <b-form-group>
          <div class="d-flex justify-content-between flex-wrap">
            <b-button type="submit" variant="primary" :disabled="deliveryBtn.disabled">
              {{ deliveryBtn.text }}
            </b-button>

            <b-button variant="danger" class="ml-3" :disabled="deliveryBtn.disabled"
              @click="cancel">
              Cancel
            </b-button>
          </div>
        </b-form-group>
      </b-form>

      <!-- DELIVERY LIST -->
      <div v-if="deliveryList.length && !addDelivery">
        <table class="table table-striped table-bordered">
          <thead class="text-left thead-dark">
            <tr>
              <th>Delivery Type</th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(delivery, index) in deliveryList" :key="index">
              <td class="align-middle">{{ delivery.name }}</td>

              <td class="align-middle">
                <span v-if="delivery.view_order == '0'"
                  class="btn m-0 p-0 text-info"
                  @click="getSpecificDelivery(delivery.id, { hide: true })">
                  <i class="far fa-eye-slash"></i>
                </span>

                <span v-else class="btn m-0 p-0 text-info"
                  @click="getSpecificDelivery(delivery.id, { hide: false })">
                  <i class="far fa-eye"></i>
                </span>
              </td>

              <td class="align-middle">
                <span class="btn m-0 p-0 text-info"
                  @click="getSpecificDelivery(delivery.id)">
                  <i class="far fa-edit"></i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ------------------------------------- -->
      <!-- TEACHING METHODOLOGY -->
      <!-- ------------------------------------- -->

      <h5 class="font-weight-bolder mt-5">Teaching Methodology</h5>

      <b-button variant="primary" size="md" class="ml-4 mt-2"
        v-if="!addTeaching"
        @click="addTeaching = true">
        Add Teaching Methodology
      </b-button>

      <!-- Teaching Form -->
      <b-form class="mt-4" v-if="addTeaching" @submit.prevent="createTeaching">
        <b-form-group>
          <span class="alert alert-success text-center" v-if="teachingSuccess">
            {{ teachingSuccess }}
          </span>

          <h6 v-if="teachingErrors.updated" class="text-success">
            {{ teachingErrors.updated[0] }}
          </h6>
        </b-form-group>

        <b-form-group>
          <b-input
            placeholder="Teaching Methodology Name"
            v-model="teaching.name"
            class="text-center"
            :class="{ 'is-invalid': teachingErrors.name }"
          />

          <span class="text-danger" v-if="teachingErrors.name">
            {{ teachingErrors.name[0] }}
          </span>
        </b-form-group>

        <b-form-group>
          <b-form-select
            v-model="teaching.view_order"
            :options="viewOrderList"
            class="text-center"
            :class="{ 'is-invalid': teachingErrors.view_order }"
          />

          <span class="text-danger ml-4" v-if="teachingErrors.view_order">
            {{ teachingErrors.view_order[0] }}
          </span>
        </b-form-group>

        <b-form-group>
          <b-button type="submit" variant="primary" :disabled="teachingBtn.disabled">
            {{ teachingBtn.text }}
          </b-button>

          <b-button variant="danger" class="ml-3"
            :disabled="teachingBtn.disabled"
            @click="cancelTeaching">
            Cancel
          </b-button>
        </b-form-group>
      </b-form>

      <!-- Teaching List -->
      <div v-if="teachingList.length && !addTeaching">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead class="thead-dark text-left">
              <tr>
                <th>Teaching Methodology</th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(teach, index) in teachingList" :key="index">
                <td class="align-middle">{{ teach.name }}</td>

                <td class="align-middle">
                  <span v-if="teach.view_order == '0'"
                    class="btn m-0 p-0 text-info"
                    @click="getSpecificTeaching(teach.id, { hide: true })">
                    <i class="far fa-eye-slash"></i>
                  </span>

                  <span v-else
                    class="btn m-0 p-0 text-info"
                    @click="getSpecificTeaching(teach.id, { hide: false })">
                    <i class="far fa-eye"></i>
                  </span>
                </td>

                <td class="align-middle">
                  <span class="btn m-0 p-0 text-info"
                    @click="getSpecificTeaching(teach.id)">
                    <i class="far fa-edit"></i>
                  </span>
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  created() {
    this.getDelivery();
    this.getTeaching();
  },

  data() {
    return {
      /** Teaching */
      addTeaching: false,
      teaching: {},
      teachingList: [],
      teachingId: "",
      teachingSuccess: "",
      teachingErrors: {},
      teachingBtn: { text: "Submit", disabled: false },

      /** Delivery */
      fetchData: false,
      deliveryId: "",
      delivery: {},
      successResponse: "",
      viewOrderList: [],
      addDelivery: false,
      deliveryList: [],
      deliveryBtn: { text: "Submit", disabled: false },
      responseErrors: {},
    };
  },

  methods: {
    /* --------------------------------------------------
     CREATE TEACHING
    -------------------------------------------------- */
    createTeaching() {
      this.teachingBtn.text = "Please wait...";
      this.teachingBtn.disabled = true;

      if (this.teachingId) return this.updateTeaching();

      const url = `${this.$store.getters.getAPIKey.mainAPI}/teachermethedologys`;

      axios
        .post(url, this.teaching)
        .then(() => {
          this.teachingSuccess = `${this.teaching.name} added successfully.`;
          this.getTeaching();
          this.clearTeaching();
        })
        .catch((error) => {
          this.teachingErrors = error.response.data.errors;
          this.clearTeachingButton();
        });
    },

    getTeaching() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/teachermethedologys`;
      axios.get(url).then((response) => {
        this.teachingList = response.data;
      });
    },

    getSpecificTeaching(id, hide) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/teachermethedologys/${id}`;

      axios.get(url).then((response) => {
        if (hide !== undefined) {
          this.teachingId = response.data.id;
          this.teaching.name = response.data.name;
          this.teaching.view_order = hide.hide ? "0" : "1";
          this.updateTeaching();
        } else {
          this.$smoothScroll({
            scrollTo: this.$refs.sessionForm,
            duration: 1000,
            offset: -50,
          });

          this.addTeaching = true;
          this.teachingId = response.data.id;
          this.teaching.name = response.data.name;
          this.teaching.view_order = response.data.view_order;
        }
      });
    },

    updateTeaching() {
      this.teachingBtn.text = "Updating...";
      this.teachingBtn.disabled = true;

      const url = `${this.$store.getters.getAPIKey.mainAPI}/teachermethedologys/${this.teachingId}`;

      axios
        .put(url, this.teaching)
        .then(() => {
          this.teachingErrors = {
            updated: [`${this.teaching.name} updated successfully.`],
          };
          this.teachingId = "";
          this.getTeaching();
          this.clearTeaching();
        })
        .catch((error) => {
          this.teachingErrors = error.response.data.errors;
          this.clearTeachingButton();
        });
    },

    cancelTeaching() {
      this.addTeaching = false;
      this.teaching = {};
      this.teachingId = "";
    },

    clearTeaching() {
      setTimeout(() => {
        this.addTeaching = false;
        this.teaching = {};
        this.teachingId = "";
        this.teachingSuccess = "";
        this.teachingErrors = {};
        this.teachingBtn = { text: "Submit", disabled: false };
      }, 2500);
    },

    clearTeachingButton() {
      this.teachingBtn.text = "Submit";
      this.teachingBtn.disabled = false;
    },

    /* --------------------------------------------------
     DELIVERY SECTION
    -------------------------------------------------- */
    createDelivery() {
      this.deliveryBtn.text = "Please wait...";
      this.deliveryBtn.disabled = true;

      if (this.deliveryId) return this.updateDelivery();

      const url = this.$store.getters.getAPIKey.deliveryType;

      axios
        .post(url, this.delivery)
        .then(() => {
          this.successResponse = `${this.delivery.name} is successfully created.`;
          this.getDelivery();
          this.clearResponse();
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          this.clearResponse();
        });
    },

    getDelivery() {
      this.fetchData = true;
      const url = this.$store.getters.getAPIKey.deliveryType;

      axios.get(url).then((response) => {
        this.deliveryList = response.data;
        this.viewOrderList = [{ value: null, text: "Select Order" }];

        let count = this.deliveryList.length + 1;
        for (let i = 1; i <= count; i++) {
          this.viewOrderList.push({ value: i.toString(), text: i });
        }

        this.fetchData = false;
      });
    },

    getSpecificDelivery(id, hide) {
      const url = `${this.$store.getters.getAPIKey.deliveryType}/${id}`;

      axios.get(url).then((response) => {
        if (hide !== undefined) {
          this.deliveryId = response.data.id;
          this.delivery.name = response.data.name;
          this.delivery.view_order = hide.hide ? "0" : "1";
          this.updateDelivery();
        } else {
          this.$smoothScroll({
            scrollTo: this.$refs.sessionForm,
            duration: 1000,
            offset: -50,
          });

          this.addDelivery = true;
          this.deliveryId = response.data.id;
          this.delivery.name = response.data.name;
          this.delivery.view_order = response.data.view_order;
        }
      });
    },

    updateDelivery() {
      this.deliveryBtn.text = "Updating...";
      this.deliveryBtn.disabled = true;

      const url = `${this.$store.getters.getAPIKey.deliveryType}/${this.deliveryId}`;

      axios
        .put(url, this.delivery)
        .then(() => {
          this.responseErrors = {
            deliveryCreated: [`${this.delivery.name} is successfully updated.`],
          };
          this.deliveryId = "";
          this.getDelivery();
          this.clearResponse();
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          this.clearResponse();
        });
    },

    cancel() {
      this.addDelivery = false;
      this.delivery = {};
      this.deliveryId = "";
    },

    clearResponse() {
      setTimeout(() => {
        this.addDelivery = false;
        this.delivery = {};
        this.deliveryId = "";
        this.responseErrors = {};
        this.successResponse = "";
        this.deliveryBtn = { text: "Submit", disabled: false };
      }, 2500);
    },
  },
};
</script>

<style>
#deliveryList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

#deliveryList .list-group-item {
  width: 250px;
}
</style>
